import angular from 'angular';
import template from './template.html';
import logger from '../../shared/logger';
import './style.scss';

export const DEFAULT_OFFICE = 'OFFICE_USA';

export class OfficeList {
    officeList = [];
    officeListOptions = [];
    selectedOffice = DEFAULT_OFFICE;

    /* @ngInject */
    constructor(OfficeService, $scope, $localStorage, $state, $window) {
        this.$scope = $scope;
        this.officeService = OfficeService;
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$window = $window;
    }

    async $onInit() {
        try {
            const { result } = await this.officeService.getOfficeGroups() || {};

            if (result) {
                this.officeList = result;
                this.officeListOptions = (result || []).map(office => ({ value: office, label: office }));
            }
        } catch (error) {
            logger.error(error)
        }
    }

    $onChanges() {
        const {
            defaultOffice,
            $localStorage: {
                activeOffice,
            },
        } = this;

        if (activeOffice) {
            this.selectedOffice = activeOffice;
        } else if (defaultOffice) {
            this.setOffice(defaultOffice);
        }
    }

    onOfficeChange({ value }) {
        angular.element(this.$window).off('scroll');
        this.setOffice(value);
    }

    setOffice(office) {
        this.$localStorage.activeOffice = office;
        this.$state.reload();
    }
}

export const OfficeListConfiguration = {
    template,
    bindings: {
        defaultOffice: '<',
    },
    controller: OfficeList,
    controllerAs: 'officeListCtrl',
};

angular
    .module('TALENYA-FE')
    .component('officeList', OfficeListConfiguration);
